export const checkOptions: any = [
  { name: 'Sí', value: true },
  { name: 'No', value: false },
];

export enum FilePreviewTypes {
  LIST = 'list',
  COUNT = 'count',
}
